const XLogo = ({ color = "#000", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="Icon-module__icon-Ndb5"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill={color}
      d="M27.75 20.94 42.32 4h-3.45L26.22 18.7 16.12 4H4.45l15.28 22.24L4.46 44H7.9l13.36-15.53L31.94 44H43.6L27.75 20.94Zm-4.73 5.5-1.55-2.22L9.15 6.6h5.3l9.95 14.22 1.55 2.21 12.92 18.49h-5.3L23.02 26.44Z"
    />
  </svg>
);
export default XLogo;
